previewGateVisible